import React from 'react';
import { REQUIRE_SUPPLEMENT } from '../../order-sale-form';
import { RhCheckbox } from '../../../../../../../dum';
import { useReceiptAppliesTax } from '../../helpers/use-receipt-applies-tax';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function RequireSupplementInput() {
    const appliesTax = useReceiptAppliesTax();
    return (
        <RhCheckbox
            name={REQUIRE_SUPPLEMENT}
            label={shortLabel(FIELD_LABELS.require_supplement)}
            disabled={!appliesTax}
        />
    );
}
